import { render, staticRenderFns } from "./cms-block-table-row.vue?vue&type=template&id=a0f074cc&scoped=true"
import script from "./cms-block-table-row.vue?vue&type=script&lang=js"
export * from "./cms-block-table-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f074cc",
  null
  
)

export default component.exports